import React from 'react';
import './eyeinvestigation.css';

function EyeInvestigation() {
  return (
    <>
            {/* Banner Image */}
            <div className="eyeinvestigation-banner">  
            <img src="/eyeinvestigation.jpg" alt="eyeinvestigation Banner" className="eyeinvestigation-banner-image" />
          </div>

    <div className="eyeinvestigation-container">


      <div className="eyeinvestigation-section">
      <h1>Eye Investigations</h1>
</div>

        <div className="eyeinvestigation-section">
          <h2>Refraction</h2>
          <p>
            Refractive error occurs when there is difficulty in seeing objects or faces clearly. Normally, a person can view both distant and nearby objects without experiencing discomfort or blurriness.
          </p>
          <p>
            Refractive errors are commonly found in children. For instance, they may sit very close to the television or hold books right up to their eyes. They might also avoid outdoor activities and struggle to copy notes from the board, often resulting in incomplete notes and poor handwriting. Additionally, children may frequently experience headaches, particularly after school, due to excessive eye strain during prolonged studying.
          </p>
          <p>
            In adults, reading can become more difficult, requiring them to hold books farther away or squint to focus. Fortunately, these issues can be easily corrected with prescription glasses following a comprehensive eye examination.
          </p>
          <p>
            Clear vision is an invaluable sense, and proper focusing of light inside the eye is essential for sharp sight. If you are experiencing vision difficulties, Vision Care is here to help. A refraction test is necessary to determine the right prescription for spectacles, contact lenses, or other optical aids.
          </p>
          <p>
            We recommend a yearly refraction test for individuals of all ages.
          </p>
        </div>

        <div className="eyeinvestigation-section">
          <h2>Eye Pressure (Intraocular Pressure - IOP)</h2>
          <p>
            Intraocular pressure (IOP) refers to the internal fluid pressure within the eye. The eyeball is not hollow; it continuously produces fluids and gels that nourish the eye and maintain its shape. However, when the eye’s drainage system malfunctions, excess fluid accumulates, leading to increased pressure, which can result in glaucoma.
          </p>
          <h3>Risk Factors for Glaucoma</h3>
          <ul>
            <li>Age: Individuals over 40 have a higher risk.</li>
            <li>Family History: A family history of glaucoma increases the chances of developing the condition.</li>
            <li>Medical Conditions: Diabetes, high blood pressure, and heart disease can contribute to elevated eye pressure.</li>
            <li>Physical Injury: Serious eye trauma can cause sudden pressure buildup.</li>
            <li>Medication Use: Prolonged use of certain medications can lead to increased eye pressure in some cases.</li>
          </ul>
          <h3>Methods for Measuring Eye Pressure:</h3>
          <ul>
            <li>Air Puff Tonometry (non-contact method)</li>
            <li>Pascal Tonometer (contact method)</li>
          </ul>
        </div>

        <div className="eyeinvestigation-section">
          <h2>Biometry</h2>
          <p>
            The natural lens of the eye plays a key role in focusing light to provide clear vision at different distances. However, with aging or conditions such as diabetes, the lens may become cloudy or lose its transparency, resulting in blurred vision. In such cases, surgeons replace the affected lens with an artificial one.
          </p>
          <p>
            Measuring the required power for the replacement lens is known as biometry or an A-scan. Your eye surgeon will determine the most suitable lens, and an optometrist will conduct the test. We recommend bringing a companion, as the procedure may take approximately 30 minutes.
          </p>
        </div>

        <div className="eyeinvestigation-section">
          <h2>Color Vision</h2>
          <p>
            Colors add vibrancy to our world, but not everyone perceives them in the same way. Specialized cells in the eye’s neural layer are responsible for color vision. When these cells are deficient, individuals may have difficulty distinguishing certain colors, resulting in a unique perception of the world. Color vision deficiencies are often inherited and, while not harmful, early detection is crucial for adapting educational strategies for children.
          </p>
          <h3>Available Tests:</h3>
          <ul>
            <li>Ishihara’s Test for Color Vision</li>
            <li>D-15 Color Vision Test</li>
          </ul>
        </div>

        <div className="eyeinvestigation-section">
          <h2>Visual Fields</h2>
          <p>
            A visual field test helps to assess the range of vision, including peripheral vision (above, below, and to the sides), while central vision remains the sharpest. This test is a standard part of routine eye examinations and is essential for detecting conditions such as glaucoma or neurological disorders.
          </p>
          <p>
            Following your eye doctor’s recommendations for visual field tests is crucial, as they help monitor changes in peripheral vision and ensure overall eye health.
          </p>

      </div>


    </div>
    </>
  );
}

export default EyeInvestigation;


  